/**
 * 查询列表
 */
 import Layout from '../../pages/layout/Frame';

 const queryRouter = {
     path: "/queryList",
     component: Layout,
     meta: {title: '查询列表'},
     name: "query_list",
     children: [
         {
             path: "/queryList/index",
             component: () => import('../../pages/queryList/index'),
             meta: {title: '查询列表',},
             name: 'query_list',
         },
     ]
 };
 
 export default queryRouter
 